import React from 'react'
import FORM from '../../assets/form.pdf'

const CTA = () => {
  return (
    <div className='cta'>
        <a href={FORM} download className='btn'>Download FORM</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default CTA
